<a
  class="kr-sidebar-nav-item"
  [routerLink]="link()"
  [routerLinkActiveOptions]="activeOptions"
  routerLinkActive="kr-sidebar-nav-item_active"
  #rla="routerLinkActive">
  @if (rla.isActive) {
    <fu-icon [iconName]="iconName() + '-filled'"></fu-icon>
  } @else {
    <fu-icon [iconName]="iconName()"></fu-icon>
  }

  <span class="kr-sidebar-nav-item__name" [translate]="i18nKey()"> </span>
</a>
